module.exports = __webpack_public_path__ + "static/media/x.2528ae87.svg";